/**
 * Created by comoon on 1/27/16.
 */

var BEIJING = {
    id: 14873,
    name: '北京市'
};

var SHANGHAI = {
    id: 21838,
    name: '上海市'
};

var GUANGZHOU = {
    id: 22050,
    name: '广州市'
};

var HONGKONG = {
    id: 90653,
    name: '香港'
};

var cities = [
    BEIJING, SHANGHAI, GUANGZHOU, HONGKONG
];

module.exports = cities;

module.exports.BEIJING = BEIJING;


/** WEBPACK FOOTER **
 ** ./script/conf/start-city.js
 **/